import React from "react";

export const MobileSidebarContext = React.createContext<{ open: () => void }>({
  open: () => {},
});

export function useMobileSidebar() {
  return React.useContext(MobileSidebarContext);
}

/** Empty slot at the top-right of the phone top bar. */
export const MobileTopBarSlotContext = React.createContext<HTMLDivElement | null>(null);

export const MobileTopBarSlotSetterContext = React.createContext<
  (el: HTMLDivElement | null) => void
>(() => {});

export function useMobileTopBarSlot() {
  return React.useContext(MobileTopBarSlotContext);
}

/** Center of the phone bottom nav. The workbench docks its event stepper here. */
export const MobileBottomNavSlotContext = React.createContext<HTMLDivElement | null>(null);

export const MobileBottomNavSlotSetterContext = React.createContext<
  (el: HTMLDivElement | null) => void
>(() => {});

export function useMobileBottomNavSlot() {
  return React.useContext(MobileBottomNavSlotContext);
}

/** Shared visibility for content that floats just above the phone navigation. */
export const MobileBottomNavVisibilityContext = React.createContext<{
  hidden: boolean;
  setHidden: (hidden: boolean) => void;
}>({ hidden: false, setHidden: () => {} });

export function useMobileBottomNavHidden() {
  return React.useContext(MobileBottomNavVisibilityContext).hidden;
}
